(function() {
    'use strict';
    
    let cartUpdateInterval;
    let rapidUpdateInterval;
    const cartCounterClass = '.header__cart-counter';
    const RAPID_UPDATE_INTERVAL = 100;
    const RAPID_UPDATE_DURATION = 5000;
    const NORMAL_UPDATE_INTERVAL = 30000;
    
    async function updateCartCount() {
        try {
            const response = await fetch('/cart.js');
            const cartData = await response.json();
            const itemCount = cartData.item_count || 0;
            
            document.querySelectorAll(cartCounterClass).forEach(counter => {
                counter.textContent = itemCount;
            });
            
            if (window.Alpine && window.Alpine.store && window.Alpine.store('cart_count')) {
                window.Alpine.store('cart_count').count = itemCount;
            }
            
        } catch (error) {}
    }
    
    function startRapidUpdates() {
        if (rapidUpdateInterval) {
            clearInterval(rapidUpdateInterval);
        }
        
        if (cartUpdateInterval) {
            clearInterval(cartUpdateInterval);
        }
        
        updateCartCount();
        
        rapidUpdateInterval = setInterval(updateCartCount, RAPID_UPDATE_INTERVAL);
        
        setTimeout(() => {
            if (rapidUpdateInterval) {
                clearInterval(rapidUpdateInterval);
                rapidUpdateInterval = null;
            }
            
            startNormalUpdates();
        }, RAPID_UPDATE_DURATION);
    }
    
    function startNormalUpdates() {
        if (cartUpdateInterval) {
            clearInterval(cartUpdateInterval);
        }
        
        cartUpdateInterval = setInterval(updateCartCount, NORMAL_UPDATE_INTERVAL);
    }
    
    function startCartUpdates() {
        if (document.querySelector(cartCounterClass)) {
            updateCartCount();
            startNormalUpdates();
        }
    }
    
    function setupCartEventListeners() {
        document.addEventListener('submit', function(e) {
            const form = e.target;
            if (form && form.action && (form.action.includes('/cart/add') || 
                (form.method === 'post' && form.getAttribute('action')?.includes('cart')))) {
                startRapidUpdates();
            }
        });
        
        document.addEventListener('click', function(e) {
            const button = e.target.closest('[type="submit"], button, a');
            if (button) {
                const buttonText = button.textContent?.toLowerCase() || '';
                const buttonClass = button.className?.toLowerCase() || '';
                const buttonId = button.id?.toLowerCase() || '';
                
                if (buttonText.includes('add to cart') || 
                    buttonText.includes('add to bag') ||
                    buttonClass.includes('add-to-cart') ||
                    buttonClass.includes('cart-add') ||
                    buttonId.includes('add-to-cart') ||
                    button.getAttribute('name') === 'add' ||
                    button.getAttribute('aria-label')?.toLowerCase().includes('add to cart')) {
                    
                    startRapidUpdates();
                }
            }
        });
        
        document.addEventListener('ajax:success', function(e) {
            if (e.detail && e.detail.url && e.detail.url.includes('/cart/add')) {
                startRapidUpdates();
            }
        });
        
        document.addEventListener('shopify:section:load', function() {
            setTimeout(startCartUpdates, 100);
        });
        
        window.triggerCartUpdate = function() {
            startRapidUpdates();
        };
        
        const originalFetch = window.fetch;
        window.fetch = function(...args) {
            const [url, options] = args;
            
            if (typeof url === 'string' && 
                (url.includes('/cart/add') || 
                 (options && options.method === 'POST' && url.includes('/cart')))) {
                
                setTimeout(startRapidUpdates, 50);
            }
            
            return originalFetch.apply(this, args);
        };
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            startCartUpdates();
            setupCartEventListeners();
        });
    } else {
        startCartUpdates();
        setupCartEventListeners();
    }
    
    window.stopCartUpdates = function() {
        if (cartUpdateInterval) {
            clearInterval(cartUpdateInterval);
            cartUpdateInterval = null;
        }
        if (rapidUpdateInterval) {
            clearInterval(rapidUpdateInterval);
            rapidUpdateInterval = null;
        }
    };
    
    window.startRapidCartUpdates = startRapidUpdates;
})();